import Http from "./http";

export const updateEnrollmentAgreementAPI = (payload) => {
  return Http.post("admin/campaign/enrollment-agreement/update", payload);
};

